function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { parse } from "qs";
import WifiIcon from "../../../resources/images/icons/WifiIcon.png";
import Trans from "../intl/Trans";
import Button from "../uikit/Button";
import useDarkMode from "../../hooks/useDarkMode";
import Logo from "../../../resources/images/icons/LeftMenuLogo.svg";
import LogoDark from "../../../resources/images/icons/LeftMenuLogoDark.svg";
import Card from "../uikit/Card";
import { myCompaniesActions } from "../../redux/myCompanies";
import handleReportError from "../errors/handleReportError";
import Alert from "../uikit/Alert";
import { useApplicationLoaderContext } from "../app/ApplicationLoaderContext";
import { mapErrorByHttpStatusCode } from "../../hooks/useErrorMessage";
import { ANAF_SPV_CONNECTION_WINDOW_API_PATH } from "./utils";
import { useModalManagerContext } from "../app/ModalManagerContext";
export default function AnafSpvAccountantFinishPage() {
    /**
     * --------------------
     * Modal manager context
     * --------------------
     */ var showModalAsync = useModalManagerContext().showModalAsync;
    /**
     * --------------------
     * Hooks
     * --------------------
     */ var darkMode = useDarkMode();
    var search = useLocation().search;
    var _useTranslation = useTranslation(), translate = _useTranslation.t;
    var dispatch = useDispatch();
    var params = parse(search.substring(1));
    var businessId = params.businessId, businessName = params.businessName, userName = params.userName;
    var abortControllerRef = useRef(new AbortController());
    /**
     * --------------------
     * Local state
     * --------------------
     */ var _useState = _sliced_to_array(useState(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), internalError = _useState1[0], setInternalError = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), apiErrorMessage = _useState2[0], setApiErrorMessage = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), anafSpvActivated = _useState3[0], setAnafSpvActivated = _useState3[1];
    var onCloseHandler = function() {
        setIsLoading(false);
    };
    var handleLoadError = function(error) {
        setIsLoading(false);
        setInternalError(mapErrorByHttpStatusCode(error));
    };
    useEffect(function() {
        dispatch(myCompaniesActions.verifyFinishActivateAnafSpvAccountant(params, abortControllerRef.current.signal)).catch(function(err) {
            var _err_response_data_errors;
            if (err.response && ((_err_response_data_errors = err.response.data.errors) === null || _err_response_data_errors === void 0 ? void 0 : _err_response_data_errors.sig) === "expired") {
                setApiErrorMessage(translate("my-companies.anaf-spv.activate.step-4.accountant.error-message.expired-link"));
            } else {
                setApiErrorMessage(translate("my-companies.anaf-spv.activate.step-4.accountant.error-message.invalid-link"));
            }
            handleReportError(err);
        });
    }, []);
    var setIsPageLoaderShown = useApplicationLoaderContext().setIsPageLoaderShown;
    useEffect(function() {
        setIsPageLoaderShown(false);
        return function() {
            return setIsPageLoaderShown(true);
        };
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-screen items-center md:p-20 2xl:mx-20 4xl:mx-40"
    }, /*#__PURE__*/ React.createElement(Card, {
        className: "min-h-screen w-full flex-row items-center justify-evenly gap-x-10 sm:rounded-none md:min-h-full md:rounded-xl md:p-20 2xl:p-40"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex max-w-3xl flex-col items-center gap-y-5 "
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mr-3 flex w-full max-w-lg items-center justify-center"
    }, darkMode && /*#__PURE__*/ React.createElement(LogoDark, {
        className: "h-40 w-60"
    }), !darkMode && /*#__PURE__*/ React.createElement(Logo, {
        className: "h-40 w-60"
    })), (apiErrorMessage || internalError) && /*#__PURE__*/ React.createElement(Alert, {
        variant: "danger",
        className: "mb-5 w-full"
    }, apiErrorMessage && apiErrorMessage, internalError && internalError), /*#__PURE__*/ React.createElement("div", {
        className: "text-2xl font-semibold"
    }, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.title-", /*#__PURE__*/ React.createElement("span", {
        className: "font-bold text-gray-500"
    }, {
        businessId: businessId
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-5 text-xl font-semibold  text-gray-500"
    }, businessName), /*#__PURE__*/ React.createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.subtitle1-", /*#__PURE__*/ React.createElement("span", {
        className: "font-bold"
    }, {
        userName: userName
    }, " "), "-", /*#__PURE__*/ React.createElement("span", {
        className: "font-bold"
    }, {
        businessName: businessName
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "mb-5 text-start"
    }, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.description")), /*#__PURE__*/ React.createElement("ul", {
        className: "mb-5 ml-5 list-disc space-y-3 text-start"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.description.1")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.description.2")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.description.3")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.description.4")))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-5 font-semibold"
    }, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.description.5")), !anafSpvActivated && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-y-5"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "max-w-xs",
        size: "medium",
        disabled: !!apiErrorMessage,
        loading: isLoading,
        onClick: function() {
            setIsLoading(true);
            showModalAsync({
                componentLoader: function() {
                    return import("./AnafSpvActivationModal");
                },
                onClose: onCloseHandler,
                initialProps: {
                    accountantActivationProps: {
                        businessId: params.businessId,
                        businessName: params.businessName,
                        expiry: params.expiry,
                        userName: params.userName,
                        other: params.other,
                        sig: params.sig,
                        setAnafSpvActivated: setAnafSpvActivated,
                        apiAction: myCompaniesActions.finishActivateAnafSpvAccountant,
                        windowApiPath: ANAF_SPV_CONNECTION_WINDOW_API_PATH.ACCOUNTANT_ACTIVATION
                    }
                },
                handleLoadError: handleLoadError
            });
        }
    }, /*#__PURE__*/ React.createElement(Trans, null, "my-companies.anaf-spv.activate.step-4.accountant.submit-btn")))), /*#__PURE__*/ React.createElement("div", {
        className: "hidden w-fit flex-shrink-0 items-center justify-center py-6 lg:flex"
    }, /*#__PURE__*/ React.createElement("img", {
        src: WifiIcon,
        alt: "Wifi Icon",
        className: "lg:max-w-[300px] xl:max-w-sm 2xl:max-w-md"
    }))));
}
